if (!customElements.get("sticky-atc-bar")) {
  customElements.define(
    "sticky-atc-bar",
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add("sticky-atc-bar-enabled");

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(
          ".f-main-product-form"
        );

        this.container = this.closest(".sticky-atc-bar");

        this.mainProduct = document.querySelector(
          "product-info[id^='MainProduct']"
        );

        this.variantData = this.getVariantData();
        this.select = this.querySelector("select");

        this.init();

        // Variant sync from sticky selector
        this.select.addEventListener("change", () => {
          const mainVariantPicker =
            this.mainProduct.querySelector("variant-picker");

          const selectedVariantId = this.querySelector(
            this.selectors.variantIdSelect
          ).value;

          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(selectedVariantId)
          );

          if (mainVariantPicker) {
            Array.from(
              mainVariantPicker.querySelectorAll(
                "select, .variant-picker__option-values"
              ),
              (element) => {
                const variantOptionVal = this.currentVariant.options[
                  Array.from(element.parentNode.children).indexOf(element)
                ];

                switch (element.tagName) {
                  case "SELECT":
                    element.value = variantOptionVal;
                    break;

                  case "DIV":
                    Array.from(element.querySelectorAll("input")).forEach(
                      (radio) => {
                        radio.checked = radio.value === variantOptionVal;
                      }
                    );
                    break;
                }
              }
            );

            mainVariantPicker.dispatchEvent(new Event("change"));
          }

          this.updatePrice();
          this.updateButton(true, "", false);

          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(
              !this.currentVariant.available,
              window.FoxThemeStrings.soldOut
            );
          }
        });

    /* ================================
   STICKY ADD TO CART ACTION
================================= */
const stickyBtn = this.querySelector('[name="add"]');

if (stickyBtn) {
  stickyBtn.addEventListener("click", async (e) => {
    e.preventDefault();

    if (stickyBtn.hasAttribute("disabled")) return;

    const form = stickyBtn.closest("form");
    const variantId = form.querySelector('[name="id"]').value;
    const quantity =
      form.querySelector('[name="quantity"]')?.value || 1;

    stickyBtn.classList.add("btn--loading");
    stickyBtn.setAttribute("aria-disabled", "true");

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: parseInt(quantity, 10)
              }
            ],
            sections: "cart-drawer",
            sections_url: window.location.pathname
          })
        }
      );

      const data = await response.json();

      if (!response.ok || data.status) {
        console.error(
          "Sticky ATC error:",
          data.description || data
        );
        return;
      }

      window.FoxThemeEvents.emit(
        PUB_SUB_EVENTS.cartUpdate,
        data
      );

      document.dispatchEvent(
        new CustomEvent("product-ajax:added", {
          detail: {
            product: data
          }
        })
      );

    } catch (error) {
      console.error("Sticky ATC error:", error);

    } finally {
      stickyBtn.classList.remove("btn--loading");
      stickyBtn.removeAttribute("aria-disabled");
    }
  });
}
      } // ← closes connectedCallback



      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.container.querySelector('[type="application/json"]').textContent
          );

        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add("sticky-atc-bar--show");
          return;
        }

        const isMobile = window.matchMedia("(max-width: 639px)");

        try {
          isMobile.addEventListener("change", this.checkDevice.bind(this));
        } catch (err) {
          try {
            isMobile.addListener(this.checkDevice.bind(this));
          } catch (e) {
            console.error(e);
          }
        }

        this.checkDevice(isMobile);

        const headerHeight = window.FoxThemeSettings.headerHeight || 80;
        const rootMargin = `-${headerHeight}px 0px 0px 0px`;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method =
                entry.intersectionRatio !== 1 ? "add" : "remove";

              this.container.classList[method]("sticky-atc-bar--show");
            });
          },
          { threshold: 1, rootMargin }
        );

        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice() {
        setTimeout(() => {
          const sectionHeight = this.clientHeight + "px";
          document.documentElement.style.setProperty(
            "--f-sticky-atc-bar-height",
            sectionHeight
          );
        }, 100);
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(
          'form[id^="product-form-"]'
        );

        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector(
          '[name="add"] > span:not(.f-icon)'
        );

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.FoxThemeStrings.addToCart;
        }
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(
          this.selectors.variantIdSelect
        ).value;

        this.currentVariant = this.variantData.find(
          (variant) => variant.id === Number(selectedVariantId)
        );

        fetch(
          `${this.getAttribute("data-url")}?variant=${
            this.currentVariant.id
          }&section_id=${this.sectionId}`
        )
          .then((res) => res.text())
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, "text/html");

            const quantity = document.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );

            const newQuantity = parsed.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );

            if (quantity && newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch(console.error);
      }

      updatePrice() {
        const money_format = window.FoxThemeSettings.money_format;

        const {
          priceWrapper,
          salePrice,
          unitPrice,
          compareAtPrice,
        } = queryDomNodes(
          {
            priceWrapper: ".f-price",
            salePrice: ".f-price-item--sale",
            compareAtPrice: [".f-price-item--regular"],
            unitPrice: ".f-price__unit",
          },
          this
        );

        const { compare_at_price, price, unit_price_measurement } =
          this.currentVariant;

        const onSale =
          compare_at_price && compare_at_price > price;

        const soldOut = !this.currentVariant.available;

        priceWrapper?.classList.toggle("f-price--on-sale", onSale);
        priceWrapper?.classList.toggle("f-price--sold-out", soldOut);

        if (salePrice) {
          salePrice.innerHTML = formatMoney(price, money_format);
        }

        if (compareAtPrice?.length) {
          compareAtPrice.forEach((el) => {
            el.innerHTML = formatMoney(
              compare_at_price || price,
              money_format
            );
          });
        }

        if (unit_price_measurement && unitPrice) {
          unitPrice.classList.remove("f-hidden");

          unitPrice.innerHTML = `
            <span>${formatMoney(
              this.currentVariant.unit_price,
              money_format
            )}</span> / <span>${getBaseUnit(this.currentVariant)}</span>
          `;
        } else {
          unitPrice?.classList.add("f-hidden");
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');

        window.FoxThemeEvents.subscribe(
          PUB_SUB_EVENTS.variantChange,
          (evt) => {
            const isMain =
              evt.data.sectionId === this.mainProduct.dataset.section;

            if (!isMain) return;

            this.currentVariant = evt.data.variant;

            if (!this.currentVariant) {
              this.container.classList.add("f-hidden");
              return;
            }

            this.container.classList.remove("f-hidden");

            variantInput.value = evt.data.variant.id;

            this.updatePrice();
            this.updateButton(
              !evt.data.variant.available,
              window.FoxThemeStrings.soldOut
            );

            this.updateQuantityInput();
          }
        );
      }
    }
  );
}